import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserStatus, getUser, BRAND_NAME } from "../../contants";
import { postLoginAuth } from "../../server/auth";
import { useAuth } from "../../context/auth-context";

export default function LoginPage() {
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { login } = useAuth();

  const role = getUserStatus();
  const user = getUser();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      if (!phone.trim()) {
        setError("Vui lòng nhập số điện thoại");
        return;
      }

      const phoneRegex = /^(0|\+84)([0-9]{9})$/;
      if (!phoneRegex.test(phone)) {
        setError("Số điện thoại không hợp lệ (phải 10 số)");
        return;
      }

      const res = await postLoginAuth(phone);

      if (!res) {
        setError("Số điện thoại không tồn tại trong hệ thống");
        return;
      }

      if (res?.token) {
        login({
          customerName: res.customerName,
          customerType: res.customerType,
          token: res.token,
        });
      }

      navigate("/");
    } catch (err) {
      console.error(err);
      setError("Đăng nhập thất bại");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-shell" role="main">
      <div className="glow" aria-hidden />

      <div className="relative mx-auto flex max-w-6xl flex-col gap-8 px-4 py-14">
        <div className="flex flex-col gap-3">
          <p className="pill self-start">
            Truy cập dành cho khách hàng {BRAND_NAME}
          </p>
          <h1 className="text-3xl font-bold text-black">Đăng nhập tài khoản</h1>
          <p className="text-slate-200 max-w-2xl">
            Quản lý đơn hàng, xem ưu đãi riêng và nhận hỗ trợ kỹ thuật nhanh chóng.
            Chúng tôi xác thực bằng số điện thoại để bảo mật cho bạn.
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1fr,1fr]">
          <div className="glass-card border border-white/10 bg-white/10 p-6 text-black">
            <div className="flex items-center gap-2 text-sm font-semibold text-slate-500">
              <span className="grid h-9 w-9 place-items-center rounded-full bg-white/10">
                01
              </span>
              <span>Kết nối chuyên viên</span>
            </div>
            <h2 className="mt-3 text-2xl font-bold text-black">Khách hàng doanh nghiệp?</h2>
            <p className="mt-2 text-slate-500">
              Để nhận chính sách giá tốt và hỗ trợ triển khai, hãy đăng nhập hoặc để lại số
              điện thoại.
            </p>
            <ul className="mt-4 space-y-2 text-sm text-slate-500">
              <li>• Theo dõi đơn hàng và bảo hành trực tuyến</li>
              <li>• Ưu đãi riêng cho đại lý/khách doanh nghiệp</li>
              <li>• Hỗ trợ kỹ thuật và tư vấn cấu hình</li>
              <li>• Giao hàng nhanh toàn quốc</li>
            </ul>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <div className="rounded-full bg-white/15 px-3 py-2 text-sm">
                Hotline: 1800-0000
              </div>
              <div className="rounded-full bg-white/15 px-3 py-2 text-sm">
                Email: support@vtech.vn
              </div>
            </div>
          </div>

          <div className="auth-card p-6">
            {role ? (
              <div className="space-y-4">
                <p className="text-sm font-semibold text-slate-500">Bạn đã đăng nhập</p>
                <h2 className="text-2xl font-bold text-slate-900">
                  Xin chào, {user.customerNamne || "khách hàng"}!
                </h2>
                <p className="text-slate-600">
                  Bạn có thể quay lại trang chủ để tiếp tục mua sắm hoặc xem đơn hàng.
                </p>
                <a
                  href="/"
                  className="inline-flex items-center justify-center rounded-xl bg-slate-900 px-4 py-2 text-black font-semibold shadow transition hover:-translate-y-0.5"
                >
                  Về trang chủ
                </a>
              </div>
            ) : (
              <div className="space-y-5">
                <div className="space-y-1">
                  <p className="text-sm font-semibold text-slate-500">Đăng nhập</p>
                  <h2 className="text-2xl font-bold text-slate-900">Nhập số điện thoại</h2>
                  <p className="text-sm text-slate-600">
                    Chúng tôi sẽ xác thực và cấp quyền truy cập ưu đãi cho tài khoản của bạn.
                  </p>
                </div>

                {error && (
                  <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
                    {error}
                  </div>
                )}

                <form className="space-y-4" onSubmit={handleSubmit} noValidate>
                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-slate-700">
                      Số điện thoại <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      className="auth-input"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      placeholder="Nhập số điện thoại (vd: 0912345678)"
                      required
                    />
                  </div>

                  <button type="submit" className="auth-button" disabled={isLoading}>
                    {isLoading ? "Đang xử lý..." : "Đăng nhập"}
                  </button>
                </form>

                <div className="rounded-xl border border-slate-100 bg-slate-50 px-4 py-3 text-sm text-slate-600">
                  <p className="font-semibold text-slate-800">Lưu ý bảo mật</p>
                  <p>Không chia sẻ mã xác thực hoặc thông tin đăng nhập với người khác.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
